// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"90fec180","97":"83897bce","306":"1a81f49c","821":"fc56d858","858":"598eb6b0","966":"c1c4263d","973":"c1c4263d"}[chunkId] + ".chunk.css";
};